import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTranslationRadioGroupComponent } from './fi-translation-radio-group.component';
import { MatRadioModule } from '@angular/material/radio';
import { FiAppTextSharedModule } from '../app-text';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [FiTranslationRadioGroupComponent],
    imports: [CommonModule, MatRadioModule, FiAppTextSharedModule, FormsModule],
    exports: [FiTranslationRadioGroupComponent],
})
export class FiTranslationRadioGroupModule {}
